export default __webpack_public_path__ + "static/media/incorrect-answer.95925393.svg";